import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Merge conditional class names, with later Tailwind utilities winning over
 * earlier ones in the same group. Lets a consumer override a primitive's
 * padding or colour without fighting specificity.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map